import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

export type EngagementTrendPoint = {
  name: string;
  engagement: number;
};

export interface EngagementTrendChartProps {
  data: EngagementTrendPoint[];
  title?: string;
  height?: number;
}

export const EngagementTrendChart: React.FC<EngagementTrendChartProps> = ({
  data,
  title = "Engagement Rate Trend",
  height = 250,
}) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-6">
        {title}
      </h2>

      <ResponsiveContainer width="100%" height={height}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar
            dataKey="engagement"
            fill="#8b5cf6"
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default EngagementTrendChart;
